<template>
  <div class="document-editor">
    <document-editor :key="projectId + documentId" :document-id="documentId" :project-id="projectId" :is-modal="isModal" @close="$emit('close')" @update="$emit('update')"></document-editor>
  </div>
</template>

<script>
export default {
  name: "DocumentEditorPage",
  components: {
    DocumentEditor: () => import('@/components/Document/DocumentEditor'),
  },
  props: {
    id: [String, Number],
    idProject: [String, Number],
    isModal: Boolean,
  },
  data: () => ({
    document: {},
    storeOverflow: "",
  }),
  computed: {
    projectId() {
      return this.idProject || this.$route.params.project;
    },
    documentId() {
      return this.id || this.$route.params.document;
    },
  },
  created() {
    this.storeOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";
  },
  beforeDestroy() {
    document.documentElement.style.overflow = this.storeOverflow;
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
  .document-editor {
    height: 100%;
    position: relative;
  }
</style>
